import { inject, Injectable } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogTrackerService } from '@app/core/services/dialog-tracker/dialog-tracker.service';
import { DialogPictureGallerySliderComponent } from '@app/core/picture-gallery/dialogs/dialog-picture-gallery-slider/dialog-picture-gallery-slider.component';
import { IPictureGallerySliderPopupData } from '@app/core/picture-gallery/interfaces/picture-gallery-slider-popup-data.interface';

@Injectable({
  providedIn: 'root',
})
export class PictureGallerySliderPopupService {
  private dialogTrackerService = inject(DialogTrackerService);

  public open(data: IPictureGallerySliderPopupData): DynamicDialogRef {
    const config = this.dialogTrackerService.getMaximizedDialogConfig();

    return this.dialogTrackerService.regAndOpen(DialogPictureGallerySliderComponent, {
      ...config,
      modal: true,
      showHeader: false,
      closeOnEscape: true,
      styleClass: '!m-0 !p-0 !w-full !max-h-full !bg-transparent !shadow-none !border-0 !rounded-none',
      maskStyleClass: '!z-app-overlay-0',
      data,
    });
  }
}
